/* eslint-env browser */

function selectChar(value) {
  return value === 'a' ? '@' : '.'
}

function isSpecial(value) {
  return value === 'a' || value === 'd'
}

function replace(value) {
  return isSpecial(value) ? selectChar(value) : value
}

function changeMail(item) {
  return item.split('|').map(value => replace(value)).join('')
}

function setMail() {
  const mail = document.querySelector('.about .mail')
  fastdom.measure(() => {
    if (mail) {
      const href = mail.getAttribute('href')
      const text = mail.textContent
      fastdom.mutate(() => {
        mail.setAttribute('href', changeMail(href))
        mail.textContent = changeMail(text)
      })
    }
  })
}

setMail()
